export default "__VITE_ASSET__MveurFIQ__"